import { Theme } from "@mui/material";

// File to be deleted on implementation of grid style

export const contentLayoutStyle = (theme: Theme) => ({
  "display": "flex",
  "flexDirection": "column",
  "gap": "1.5rem",
  ".headerSection": {
    display: "flex",
    padding: "16px 0px",
    justifyContent: "space-between",
    alignItems: "center",
    alignSelf: "stretch",
  },
  ".title": {
    display: "flex",
    alignItems: "center",
    gap: "16px",
  },
});

export const layoutContentStyle=(theme: Theme) =>({
  display: "flex",
  flexDirection: "column",
  flexGrow: 1,
  minWidth: 0,
  padding: "1rem 1rem 1rem",
  [theme.breakpoints.up(600)]: {
    padding: "1rem 1.5rem 0 1.5rem",
  },
  [theme.breakpoints.up(1200)]: {
    // 80px page margin per the Figma web frames (universal across pages).
    // Keep layoutContentStyle, layoutPadding, and wellnessPlanHeaderPadding
    // horizontals in lockstep or titles drift from page content.
    padding: "1rem 5rem 0 5rem",
  },
});

export const layoutPadding=(theme: Theme) =>({
  padding: "5.625rem 1rem 0 1rem",
  [theme.breakpoints.up(600)]: {
    padding: "2.5rem 1.5rem 0 1.5rem",
  },
  [theme.breakpoints.up(1200)]: {
    padding: "4rem 5rem 0 5rem",
  },
});

export const wellnessPlanHeaderPadding = (theme: Theme) => ({
  padding: "5.625rem 1rem 2.5rem 1rem",
  [theme.breakpoints.up(600)]: {
    padding: "2.5rem 1.5rem 2.5rem 1.5rem",
  },
  [theme.breakpoints.up(1200)]: {
    padding: "4rem 5rem 8.5rem 5rem",
  },
  backgroundImage: "url(\"/assets/icons/wellnessPlanHeaderBackground.svg\")",
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
});

export const wellnessPlanNoBackgroundHeader = (theme: Theme) => ({
  padding: "5.625rem 1rem 2.5rem 1rem",
  [theme.breakpoints.up(600)]: {
    padding: "2.5rem 1.5rem 2.5rem 1.5rem",
  },
  [theme.breakpoints.up(1200)]: {
    padding: "4rem 5rem 8.5rem 5rem",
  },
});
